class BenefitsStrip extends HTMLElement {
  constructor() {
    super();
    
    this.autoplay = this.dataset.autoplay === 'true';
    this.direction = this.dataset.direction || 'left';
    this.speed = parseInt(this.dataset.speed) || 30;
    this.gapDesktop = parseInt(this.dataset.gapDesktop) || 0;
    this.gapMobile = parseInt(this.dataset.gapMobile) || 0;
    this.layout = this.dataset.layout || 'scroll';
    this.itemsPerRowDesktop = parseInt(this.dataset.itemsPerRowDesktop) || 7;
    this.itemsPerRowMobile = parseInt(this.dataset.itemsPerRowMobile) || 3;
    
    this.strip = this.querySelector('.benefits-strip');
    this.itemsContainer = this.querySelector('.benefits-items-container');
    this.animationFrame = null;
    this.scrollPosition = 0;
    this.isHovered = false;
    this.totalItems = 0;
    
    this.init();
  }
  
  init() {
    if (!this.strip && !this.itemsContainer) return;
    
    this.totalItems = this.querySelectorAll('.benefit-item').length;
    
    if (this.totalItems > 7) {
      this.layout = 'grid';
      this.setAttribute('data-layout', 'grid');
    }
    
    this.applyStyles();
    
    if (this.autoplay && this.layout === 'scroll') {
      this.setupAutoplay();
    }
    
    window.addEventListener('resize', () => this.handleResize());
  }
  
  applyStyles() {
    const isMobile = window.innerWidth <= 768;
    
    if (this.layout === 'grid') {
      this.setupGridLayout(isMobile);
    } else {
      this.setupScrollLayout(isMobile);
    }
    
    this.applyItemStyles(isMobile);
  }
  
  setupScrollLayout(isMobile) {
    if (!this.strip) return;
    
    this.strip.style.display = 'flex';
    this.strip.style.alignItems = 'center';
    this.strip.style.gap = isMobile ? `${this.gapMobile}px` : `${this.gapDesktop}px`;
    this.strip.style.overflowX = 'auto';
    this.strip.style.flexWrap = 'nowrap';
    this.strip.style.padding = '0';
    this.strip.style.margin = '0';
    this.strip.style.scrollbarWidth = 'none';
    this.strip.style.msOverflowStyle = 'none';
    
    const style = document.createElement('style');
    style.textContent = `
      .benefits-strip::-webkit-scrollbar {
        display: none;
      }
    `;
    this.strip.appendChild(style);
  }
  
  setupGridLayout(isMobile) {
    let container = this.itemsContainer;
    if (!container) {
      container = document.createElement('div');
      container.className = 'benefits-items-container';
      
      const items = this.querySelectorAll('.benefit-item');
      items.forEach(item => {
        container.appendChild(item.cloneNode(true));
        item.remove();
      });
      
      this.appendChild(container);
    }
    
    container.style.display = 'grid';
    container.style.gridTemplateColumns = `repeat(${isMobile ? this.itemsPerRowMobile : this.itemsPerRowDesktop}, 1fr)`;
    container.style.gap = isMobile ? `${this.gapMobile}px` : `${this.gapDesktop}px`;
    container.style.padding = '0';
    container.style.margin = '0';
    container.style.justifyItems = 'center';
    container.style.alignItems = 'center';
    
    if (this.strip) {
      this.strip.style.display = 'none';
    }
  }
  
  applyItemStyles(isMobile) {
    const items = this.layout === 'grid' ? 
      this.querySelectorAll('.benefits-items-container .benefit-item') : 
      this.querySelectorAll('.benefit-item');
    
    items.forEach(item => {
      const textSpan = item.querySelector('span');
      const hasText = textSpan && textSpan.textContent.trim() !== '';
      const img = item.querySelector('img');
      
      item.style.display = 'flex';
      item.style.flexDirection = 'column';
      item.style.alignItems = 'center';
      item.style.justifyContent = 'center';
      item.style.gap = '0';
      item.style.whiteSpace = 'normal';
      item.style.textAlign = 'center';
      item.style.padding = '0';
      item.style.margin = '0';
      
      if (img) {
        let iconWrapper = item.querySelector('.benefit-icon-wrapper');
        if (!iconWrapper) {
          iconWrapper = document.createElement('div');
          iconWrapper.className = 'benefit-icon-wrapper';
          img.parentNode.insertBefore(iconWrapper, img);
          iconWrapper.appendChild(img);
        }
        
        iconWrapper.style.display = 'flex';
        iconWrapper.style.alignItems = 'center';
        iconWrapper.style.justifyContent = 'center';
        iconWrapper.style.width = isMobile ? 
          `calc(${this.dataset.iconSizeMobile}px * 1.8)` : 
          `calc(${this.dataset.iconSizeDesktop}px * 1.8)`;
        iconWrapper.style.height = isMobile ? 
          `calc(${this.dataset.iconSizeMobile}px * 1.8)` : 
          `calc(${this.dataset.iconSizeDesktop}px * 1.8)`;
        iconWrapper.style.backgroundColor = this.dataset.iconBgColor || '#f5f5f5';
        iconWrapper.style.borderRadius = '50%';
        iconWrapper.style.boxShadow = this.dataset.iconShadow = 'none';
        iconWrapper.style.margin = '0';
        iconWrapper.style.padding = '0';
        
        img.style.width = isMobile ? 
          this.dataset.iconSizeMobile + 'px' : 
          this.dataset.iconSizeDesktop + 'px';
        img.style.height = isMobile ? 
          this.dataset.iconSizeMobile + 'px' : 
          this.dataset.iconSizeDesktop + 'px';
        img.style.objectFit = 'contain';
        img.style.margin = '0';
        img.style.padding = '0';
      }
      
      if (textSpan) {
        textSpan.style.margin = '0';
        textSpan.style.padding = '0';
        if (textSpan.textContent.trim() === '') {
          textSpan.style.display = 'none';
        }
      }
    });
  }
  
  handleResize() {
    const isMobile = window.innerWidth <= 768;
    
    if (this.layout === 'grid') {
      const container = this.querySelector('.benefits-items-container');
      if (container) {
        container.style.gridTemplateColumns = `repeat(${isMobile ? this.itemsPerRowMobile : this.itemsPerRowDesktop}, 1fr)`;
        container.style.gap = isMobile ? `${this.gapMobile}px` : `${this.gapDesktop}px`;
      }
    } else if (this.strip) {
      this.strip.style.gap = isMobile ? `${this.gapMobile}px` : `${this.gapDesktop}px`;
    }
    
    this.applyItemStyles(isMobile);
  }
  
  setupAutoplay() {
    if (!this.strip || this.layout !== 'scroll') return;
    
    this.strip.addEventListener('mouseenter', () => {
      this.isHovered = true;
    });
    
    this.strip.addEventListener('mouseleave', () => {
      this.isHovered = false;
    });
    
    this.animate();
  }
  
  animate() {
    if (!this.autoplay || this.isHovered || this.layout !== 'scroll') {
      this.animationFrame = requestAnimationFrame(() => this.animate());
      return;
    }
    
    const maxScroll = this.strip.scrollWidth - this.strip.clientWidth;
    
    if (maxScroll <= 0) {
      this.animationFrame = requestAnimationFrame(() => this.animate());
      return;
    }
    
    if (this.direction === 'left') {
      this.scrollPosition += 0.5;
      if (this.scrollPosition >= maxScroll) {
        this.scrollPosition = 0;
      }
    } else {
      this.scrollPosition -= 0.5;
      if (this.scrollPosition <= 0) {
        this.scrollPosition = maxScroll;
      }
    }
    
    this.strip.scrollLeft = this.scrollPosition;
    
    setTimeout(() => {
      this.animationFrame = requestAnimationFrame(() => this.animate());
    }, this.speed);
  }
  
  disconnectedCallback() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
    window.removeEventListener('resize', this.handleResize);
  }
}

customElements.define('benefits-strip', BenefitsStrip);